export * from './M11Hero';
export { M11Hero as default } from './M11Hero';
